export default class Status {
  id: number;
  status: "finish" | "partial" | null;
}
